<template>
    <keep-alive v-if="true" :include="cachedViews">
      <router-view :key="key"/>
    </keep-alive>
    <router-view v-else :key="key"/>
</template>

<script>
export default {
  name: 'RouterSection',
  computed: {
    cachedViews () {
      return this.$store.state.tagsView.cachedViews
    },
    key () {
      return this.$route.fullPath
    },
    isLocal () {
      return process.env.NODE_ENV === 'development'
    }
  }
}
</script>

<style>
</style>
